import { Children } from 'react';
import { Grid } from '@mui/material';
import palette from './palette';

const MainLayout = ({ children }) => {
  const arrayChildren = Children.toArray(children);

  return (
    <main>
      <Grid>
        {Children.map(arrayChildren, (child, index) => {
          let style = {
            backgroundColor: palette.gt_grey_light_2,
          };
          if (index % 2 == 0) {
            style.backgroundColor = palette.gt_teal_1;
          }
          return (
            <Grid className="main-layout" item sx={style}>
              {child}
            </Grid>
          );
        })}
      </Grid>
    </main>
  );
};

export default MainLayout;
